import { AppFlavour, type InviteToAppPayload } from '../../../../lib';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';
import { post } from '../../../../api/baseUrl';
import { usePatientProfile } from '../../../components/ProfileBar/hooks';
import { useState } from 'react';

export const useInviteMedicationProfilePatient = () => {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const { patientProfile } = usePatientProfile();
  const patientAccessToken = patientProfile?.access_token;
  const inviteMedProfilePatient = async (
    phoneNumber: string,
  ): Promise<{ success: boolean }> => {
    if (!patientAccessToken || !selectedTenancy) return { success: false };
    try {
      setLoading(true);
      const requestBody: InviteToAppPayload = {
        access_token: patientAccessToken,
        phone: phoneNumber,
        tenancyId: selectedTenancy.tenancy_id,
        clinicName: '',
        appFlavour: AppFlavour.MedicineProfile,
      };
      const {
        data: { message },
      } = await post('inviteToApp', requestBody);

      if (message !== 'Success') {
        return { success: false };
      }
      setSent(true);
      return { success: true };
    } catch (error) {
      console.error('Error inviting patient:', error);
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  return { inviteMedProfilePatient, isInvitingPatient: loading, sent };
};
